import React from 'react';
import IconType from './IconType';
import cn from '@utils/cn';
import IconList from './IconList';

interface IconProps extends React.HtmlHTMLAttributes<HTMLSpanElement> {
  color?: string;
  svgClassName?: string;
  alt?: string;
  icon?: IconType;
}

export function StaticIcon({ icon, className, svgClassName, ...rest }: IconProps) {
  if (!icon) {
    return null;
  }

  return (
    <span className={cn('inline-flex content-center items-center', className)} {...rest}>
      {React.cloneElement(IconList[icon], { className: svgClassName })}
    </span>
  );
}
